import { config } from '../utils/constants/api.constants';
import { convertObjectToParams } from '../utils/utils';

const {
  baseUrl,
  umsBaseUrl,
  api_version,
  user,
  group,
  addGroup,
  removeGroup,
  v1,
  admin,
  roster,
  upload,
  leave,
} = config.api.userManagement;

export default (api) => {
  const getUsers = (params) => {
    const url = `${baseUrl}${api_version}${user}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const updateUser = (userId, rawData) => {
    const url = `${baseUrl}${api_version}${user}/${userId}`;
    return new Promise((resolve, reject) => {
      api
        .put(url, rawData)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const createUser = (rawData) => {
    const url = `${baseUrl}${api_version}${user}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, rawData)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const deleteUser = (userId) => {
    const url = `${baseUrl}${api_version}${user}/${userId}`;
    return new Promise((resolve, reject) => {
      api
        .delete(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const searchGroup = (params) => {
    const url = `${baseUrl}${api_version}${group}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const createGroup = (rawData) => {
    const url = `${baseUrl}${api_version}${group}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, rawData)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const deleteGroup = (groupId) => {
    const url = `${baseUrl}${api_version}${group}/${groupId}`;
    return new Promise((resolve, reject) => {
      api
        .delete(url)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getUserGroups = (userId, params) => {
    const url = `${baseUrl}${api_version}${group}/user-${userId}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const addUserToGroup = (userId, groupId, rawData) => {
    const url = `${baseUrl}${api_version}${group}/user-${userId}${addGroup}/${groupId}`;
    return new Promise((resolve, reject) => {
      api
        .put(url, rawData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const removeUserFromGroup = (userId, groupId, rawData) => {
    const url = `${baseUrl}${api_version}${group}/user-${userId}${removeGroup}/${groupId}`;
    return new Promise((resolve, reject) => {
      api
        .put(url, rawData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const uploadRoster = (rosterType, params, file) => {
    const url = `${umsBaseUrl}${v1}${admin}${roster}/${rosterType}${upload}${convertObjectToParams(
      params
    )}`;
    let formData = new FormData();
    formData.append('file', file);

    return new Promise((resolve, reject) => {
      api
        .post(url, formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getRoster = (params) => {
    const url = `${umsBaseUrl}${v1}${admin}${roster}${convertObjectToParams(
      params
    )}`;
    return new Promise((resolve, reject) => {
      api
        .get(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getLeaves = (params) => {
    const url = `${umsBaseUrl}${v1}${leave}${convertObjectToParams(params)}`;
    return new Promise((resolve, reject) => {
      api
        .get(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const applyLeave = (params, data) => {
    const url = `${umsBaseUrl}${v1}${leave}${convertObjectToParams(params)}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const revokeLeave = (params, data = {}) => {
    const url = `${umsBaseUrl}${v1}${leave}${convertObjectToParams(params)}`;
    return new Promise((resolve, reject) => {
      api
        .delete(url, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    getUsers,
    updateUser,
    createUser,
    deleteUser,
    searchGroup,
    createGroup,
    deleteGroup,
    getUserGroups,
    addUserToGroup,
    removeUserFromGroup,
    uploadRoster,
    getRoster,
    getLeaves,
    applyLeave,
    revokeLeave,
  };
};
const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
